const AcikRizaMetni = `
                <main class="legal-texts ">
                    <h2 class="legal-text-title">
                        6698 SAYILI KİŞİSEL VERİLERİN KORUNMASI KANUNU ("KVKK") UYARINCA KİŞİSEL VERİLERİN KORUNMASI HAKKINDA <br>AÇIK RIZA METNİ
                    </h2>

                    <p>
                        <strong>HANGİSİ İNTERNET VE BİLGİ HİZMETLERİ A.Ş.</strong> ("Şirket") olarak; <span style="font-style:italic;">"Veri Sorumlusu"</span> sıfatıyla,
                    </p>

                    <ul>
                        <li>Duruma göre aşağıda belirtilen şekillerde elde ettiğimiz kişisel verilerinizin,</li>
                        <li>Hukuki ilişkilerimiz kapsamında,</li>
                        <li>İşlenmelerini gerektiren amaç çerçevesinde ve bu amaçla bağlantılı, sınırlı ve ölçülü şekilde,</li>
                        <li>Tarafımıza bildirdiğiniz veya bildirildiği şekliyle kişisel verilerin doğruluğunu ve en güncel halini koruyarak,</li>
                        <li>Kaydedileceğini, depolanacağını, muhafaza edileceğini, yeniden düzenleneceğini, kanunen bu kişisel verileri talep etmeye yetkili olan kurumlar ile paylaşılacağını ve KVKK’nın öngördüğü şartlarda, yurtiçinde üçüncü kişilere aktarılacağını, devredileceğini, sınıflandırılabileceğini ve KVKK’da sayılan sair şekillerde işlenebileceğini bildiririz.</li>
                    </ul>

                    <h2 class="legal-text-title">KİŞİSEL VERİLERİNİZİN YURT DIŞINA AKTARIMI</h2>

                    <p>
                        Kişisel verileriniz, Kişisel Verilerin Korunması Kanunu’na uygun olarak, özellikle Şirket’in verinin paylaşılmasında ilgili kişinin temel hak ve özgürlüğünü zedelemeyen meşru bir menfaati varsa ya da ilgili bir sözleşmenin ifasını gerektiriyorsa yurt dışındaki kişilere/firmalara aktarılabilir ve kişisel veriler bu kişiler/firmalar tarafından işlenebilir.
                    </p>

                    <p>
                        Tarafımızca, yurt dışına aktarılabilecek kişisel verileriniz aşağıdaki gibidir:
                    </p>

                    <div class="legal-text-table">
                        <table>
                            <tbody>
                                <tr>
                                    <th>Kimlik Verisi</th>
                                    <td>Adı, Soyadı, Doğum tarihi, TCKN</td>
                                </tr>
                                <tr>
                                    <th>İletişim Verisi</th>
                                    <td>Telefonu, e-postası, adresi, MERNİS kaydı</td>
                                </tr>
                                <tr>
                                    <th>Çalışma Verisi</th>
                                    <td>Çalıştığı şirket, çalışma şekli, mesleği, eğitim durumu</td>
                                </tr>
                                <tr>
                                    <th>Görsel ve İşitsel Veri</th>
                                    <td>Gerçek kişiye ait fotoğraf, ses kayıtları</td>
                                </tr>
                                <tr>
                                    <th>Finansal Veri</th>
                                    <td>Banka hesap bilgileri, kredi kartı bilgisi, maaş aralığı, maaş müşterisi olunan banka, peşinat miktarı, aylık maaş belgelenebilir diğer gelirler, kredi miktarı, kredi ödemeleri, kredi kart limiti, kredi kartı dönem borcu, kredi kartına sahip olunan zaman dilimi, farklı kredi kartı sahipliği, kredi kartı kullanma türü (ticari, bireysel), kredi kartının ne tür ihtiyaçlar için kullanılacağı bilgisi, kredi kartının kullanıldığı sektör bilgisi, kredi ve kredi kartı başvuru onay-red sonuçları, skor sonucu elde edilen finansal bilgiler</td>
                                </tr>
                                <tr>
                                    <th>Mobil Uygulama Kullanım Verileri</th>
                                    <td>Başvuru formu doldurulma tarihi, aldığı veya alamadığı teklifler, üye olduğu tarih, siteye login olma sıklığı/zamanları, son login tarihi, IP, tarayıcı tipi, versiyonu, sosyal medya bilgisi, ekranlar üzerinde gerçekleştirdiği hareketler</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <h2>KİŞİSEL VERİLERİNİZİN YURT DIŞINA AKTARIM AMAÇLARI</h2>

                    <p>
                        Yukarıda belirtilen kişisel verileriniz aşağıda belirtilen amaç ve sebeplerle aktarılmaktadır. <strong>Bu açık rıza metnine ilişkin "Açık rıza metnini okudum ve anladım. Kişisel verilerimin metinde belirtilen şekillerde işlenmesini onaylıyorum ve izin veriyorum" onay kutucuğunu işaretlemekle aşağıda belirtilen amaç ve sebeplerle yukarıda belirtilen kişisel verilerinizin</strong> yurt dışındaki aşağıdaki alıcı gruplarına ve belirlenen amaçlarla <strong>aktarılmasına rıza göstermiş olacaksınız;</strong>
                    </p>

                    <ul>
                        <li>Kampanyalarımızdan ve promosyonlarımızdan haberdar olmayı tercih etmeniz halinde size toplu e-posta, SMS gönderebilmek amacıyla kişisel verilerinizi yurt içinde ve yurt dışında anlaşmalı olduğumuz ilgili hizmeti veren tedarikçilere aktarıyoruz.</li>
                        <li><a href="https://www.hangikredikobi.com/hakkimizda/cerez-bildirimi">Çerez Politikası</a> çerçevesinde toplanan kişisel verileriniz, size ve diğer üye ve müşterilerimize daha iyi hizmet verebilmek için topladığımız site içerisindeki kullanıcı hareketi verileri (nereye tıklandı, ne kadar kalındı vs. gibi), bu gibi analizler yaparak iş geliştirme sağlayan şirketlere aktarıyoruz.</li>
                        <li>Kişisel verilerinizi Insider, Google Analytics, Emarsys vs gibi birlikte çalıştığımız firmalara, satış, pazarlama ve raporlama faaliyetleri için aktarabiliyoruz.</li>
                    </ul>

                    <br>
                    <br>

                    <div class="legal-text-contact">
                        <strong>İLETİŞİM BİLGİLERİ</strong>

                        <address>
                            <strong>Hangisi İnternet ve Bilgi Hizmetleri A.Ş.</strong><br>
                            Anel İş Merkezi Yamanevler Mah. Site Yolu Cad. No:5/6 34768 Ümraniye/ İstanbul
                        </address>

                        <p>
                            <strong>E-posta: </strong><a href="mailto:kvkk@hangikredikobi.com">kvkk@hangikredikobi.com</a>
                        </p>

                        <p><strong>Web Sitesi:</strong> <a href="https://www.hangikredikobi.com/">https://www.hangikredikobi.com</a></p>

                        <p><strong>MERSİS NO:</strong> 0524052734800011</p>

                    </div>
                </main>
`;
export default AcikRizaMetni;
